// 'use client';
// import Image from 'next/image';
// import Button from '../components/ui/Button';
// import Link from 'next/link';


// const SubscribeSection = () => {
//   return (
//     <section className="w-full bg-black relative overflow-hidden">
//       {/* Right gradient blur */}
//       <div className="absolute right-0 top-0 h-full w-1/2 bg-gradient-to-l from-[#0b0bff] to-transparent z-0" />

//       <div className="relative z-10 max-w-[1440px] mx-auto px-4 sm:px-6 lg:px-20 py-10 sm:py-20 flex flex-col items-center text-center">
//         {/* Heading */}
//         <h2 className="text-[20px] sm:text-[26px] md:text-[32px] lg:text-5xl font-bold bg-gradient-to-r from-[#7243FF] to-white bg-clip-text text-transparent">
//           Stay <span className="text-white">Updated</span>
//         </h2>

       

//         {/* Button */}
//         <div className="mt-6">
//           <Link href='https://lu.ma/AICapitalConnect?k=c' target="_blank" rel='noopener noreferrer nofollow'>
//           <Button
//             text=" Subscribe to our Calendar"
//             text_font_size="text-md"
//             text_font_weight="font-bold"
//             text_line_height="leading-lg"
//             text_text_align="center"
//             text_color="text-black"
//             fill_background_color="#ffffff"
//             effect_box_shadow="0px_0px_10px_#7243ff"
//             border_border="border border-[#7243ff]"
//             border_border_radius="rounded-3xl"
//             padding="16px_28px_16px_28px"
//             className="px-7 py-4 bg-[white] hover:text-white "
//           />
//           </Link>
//         </div>
//       </div>
//     </section>
//   );
// };

// export default SubscribeSection;


'use client';

import Button from '../components/ui/Button';
import Link from 'next/link';

const SubscribeSection = () => {
  return (
    <section data-component-id="src/app/SubscribeSection.tsx:55:4" data-component-path="src/app/SubscribeSection.tsx" data-component-line="55" data-component-file="SubscribeSection.tsx" data-component-name="section" data-component-content="%7B%22elementName%22%3A%22section%22%2C%22className%22%3A%22w-full%20bg-black%20relative%20overflow-hidden%20py-16%20sm%3Apy-20%22%7D" className="w-full bg-black relative overflow-hidden py-16 sm:py-20">

      {/* Side Glow Effects */}
      <div data-component-id="src/app/SubscribeSection.tsx:58:6" data-component-path="src/app/SubscribeSection.tsx" data-component-line="58" data-component-file="SubscribeSection.tsx" data-component-name="div" data-component-content="%7B%22elementName%22%3A%22div%22%2C%22className%22%3A%22absolute%20left-0%20top-0%20h-full%20w-%5B28%25%5D%20bg-gradient-to-r%20from-%5B%231D2F92%5D%20to-transparent%20blur-3xl%20opacity-80%22%7D" className="absolute left-0 top-0 h-full w-[28%] bg-gradient-to-r from-[#1D2F92] to-transparent blur-3xl opacity-80" />
      <div data-component-id="src/app/SubscribeSection.tsx:59:6" data-component-path="src/app/SubscribeSection.tsx" data-component-line="59" data-component-file="SubscribeSection.tsx" data-component-name="div" data-component-content="%7B%22elementName%22%3A%22div%22%2C%22className%22%3A%22absolute%20right-0%20top-0%20h-full%20w-%5B28%25%5D%20bg-gradient-to-l%20from-%5B%231D2F92%5D%20to-transparent%20blur-3xl%20opacity-80%22%7D" className="absolute right-0 top-0 h-full w-[28%] bg-gradient-to-l from-[#1D2F92] to-transparent blur-3xl opacity-80" />

      <div data-component-id="src/app/SubscribeSection.tsx:61:6" data-component-path="src/app/SubscribeSection.tsx" data-component-line="61" data-component-file="SubscribeSection.tsx" data-component-name="div" data-component-content="%7B%22elementName%22%3A%22div%22%2C%22className%22%3A%22relative%20z-10%20max-w-%5B1440px%5D%20mx-auto%20px-4%20sm%3Apx-6%20lg%3Apx-8%20flex%20justify-center%22%7D" className="relative z-10 max-w-[1440px] mx-auto px-4 sm:px-6 lg:px-8 flex justify-center">

        {/* Card */}
        <div data-component-id="src/app/SubscribeSection.tsx:64:8" data-component-path="src/app/SubscribeSection.tsx" data-component-line="64" data-component-file="SubscribeSection.tsx" data-component-name="div" data-component-content="%7B%22elementName%22%3A%22div%22%2C%22className%22%3A%22w-full%20max-w-%5B740px%5D%20rounded-%5B12px%5D%20border%20border-%5B%235E17EB%5D%20bg-gradient-to-b%20from-%5B%23070014%5D%20to-%5B%232B008F%5D%20px-6%20sm%3Apx-10%20py-8%20text-center%20shadow-%5B0px_0px_40px_rgba(114%2C67%2C255%2C0.35)%5D%22%7D" className="w-full max-w-[740px] rounded-[12px] border border-[#5E17EB] bg-gradient-to-b from-[#070014] to-[#2B008F] px-6 sm:px-10 py-8 text-center shadow-[0px_0px_40px_rgba(114,67,255,0.35)]">

          {/* Heading */}
          <h2 data-component-id="src/app/SubscribeSection.tsx:67:10" data-component-path="src/app/SubscribeSection.tsx" data-component-line="67" data-component-file="SubscribeSection.tsx" data-component-name="h2" data-component-content="%7B%22elementName%22%3A%22h2%22%2C%22className%22%3A%22text-white%20text-%5B28px%5D%20sm%3Atext-%5B36px%5D%20font-bold%20leading-tight%20mb-2%22%2C%22textContent%22%3A%22Stay%20Updated%22%7D" className="text-white text-[28px] sm:text-[36px] font-bold leading-tight mb-2">
            Stay Updated
          </h2>

          {/* Subtext */}
          <p data-component-id="src/app/SubscribeSection.tsx:72:10" data-component-path="src/app/SubscribeSection.tsx" data-component-line="72" data-component-file="SubscribeSection.tsx" data-component-name="p" data-component-content="%7B%22elementName%22%3A%22p%22%2C%22className%22%3A%22text-white%2F80%20text-%5B16px%5D%20sm%3Atext-%5B22px%5D%20font-normal%20mb-6%22%2C%22textContent%22%3A%22Subscribe%20to%20our%20events%20calendar%22%7D" className="text-white/80 text-[16px] sm:text-[22px] font-normal mb-6">
            Subscribe to our events calendar
          </p>

          {/* Button */}
          <Link data-component-id="src/app/SubscribeSection.tsx:77:10" data-component-path="src/app/SubscribeSection.tsx" data-component-line="77" data-component-file="SubscribeSection.tsx" data-component-name="Link" data-component-content="%7B%22elementName%22%3A%22Link%22%2C%22href%22%3A%22https%3A%2F%2Flu.ma%2FAICapitalConnect%3Fk%3Dc%22%2C%22className%22%3A%22inline-block%22%7D"
            href="https://lu.ma/AICapitalConnect?k=c"
            target="_blank"
            rel="noopener noreferrer nofollow"
            className="inline-block"
          >
            <Button data-component-id="src/app/SubscribeSection.tsx:83:12" data-component-path="src/app/SubscribeSection.tsx" data-component-line="83" data-component-file="SubscribeSection.tsx" data-component-name="Button" data-component-content="%7B%22elementName%22%3A%22Button%22%2C%22className%22%3A%22px-7%20py-4%20bg-white%20hover%3Abg-%5B%237243ff%5D%20hover%3Atext-white%20transition-colors%22%7D"
              text="Subscribe"
              text_font_size="text-md"
              text_font_weight="font-bold"
              text_line_height="leading-lg"
              text_text_align="center"
              text_color="text-black"
              fill_background_color="#ffffff"
              effect_box_shadow="0px_0px_10px_#7243ff"
              border_border="border border-[#7243ff]"
              border_border_radius="rounded-3xl"
              padding="16px_28px_16px_28px"
              className="px-7 py-4 bg-white hover:bg-[#7243ff] hover:text-white transition-colors"
            />
          </Link>

        </div>
      </div>
    </section>
  );
};

export default SubscribeSection;